<template>
  <div >
   <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
   data() {
    return {
      URL_API: '192.168',
    }
   }
 
}
</script>

<style>

</style>
